/* eslint-disable */
import { getCookie, setCookie, isWechat } from "@/utils/tools";
import router from "@/router";
import { Toast } from 'mint-ui';
import axios from "axios";
const service = axios.create();
service.defaults.baseURL = process.env.API_ROOT;
// console.info(service.defaults.baseURL)
// console.info(process.env.PAY_APPID)
service.defaults.headers.post["Content-Type"] = "application/json";

let lastConfig = null
    // 添加请求拦截器
service.interceptors.request.use(
    function(config) {
        // 在发送请求之前做些什么
        config.headers['Client-Type'] = 'web'

        if (config.url.indexOf('login') === -1) {
            config.headers['Authorization'] = getCookie('Authorization');
        }
        lastConfig = config
        return config;
    },
    function(error) {
        // 对请求错误做些什么
        // console.log(error);
        return Promise.reject(error);
    }
);

/**
 * 拦截器提示
 * @param {String} msg  提示消息
 */
function message(msg) {
  Toast({
    message: msg,
    position: 'middle',
    duration: 1500
  })
}

// 添加响应拦截器
service.interceptors.response.use(
    response => {
        // 对响应数据做点什么
        if (response.data.rc === 1001) {
            setCookie('Authorization', 'Base ' + response.data.data)
            return service(lastConfig)
        }
        return response;
    },
    error => {
        let path = '';
        if (isWechat()) {
          path = '/user/auth'
        } else {
          path = '/user/login'
        }
        // 对响应错误做点什么
        console.log(error.response.status)
        switch (error.response.status) {
            case 401:
                message('未授权，请先登录')
                router.replace({
                    path: path,
                    query: { target: router.currentRoute.fullPath }
                });
                break;
            case 404:
                message('找不到页面')
                break;
            case 405:
                message('请求方式错误')
                break;
            case 500:
                message('服务器内部错误')
                break;
            case 502:
                message('网关错误')
                break;
            default:
                message('服务器开小差啦')
        }
        return Promise.reject(error)
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js